import { observable } from "@legendapp/state";

export const $selectedSituation = observable<string>('');
export const $currentConferenceId = observable<string>('');
export const $finishedByClient = observable<boolean>(false);
